import React from "react";
import { useNavigate } from "react-router-dom";
import "./ButtonBack.scss";

const ButtonBack = ({
    onClick,
    children,
    to,
    width = "fit-content",
    className = "",
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (to) {
            navigate(to);
        } else {
            navigate(-1); // Volver a la página anterior por defecto
        }
    };

    return (
        <div className={`ButtonBack ${className}`}>
            <button style={{ width }} onClick={handleClick}>
                <i className="pi pi-arrow-left"></i>
                {children || "Regresar"}
            </button>
        </div>
    );
};

export default ButtonBack;
